module.exports = __webpack_public_path__ + "static/media/all-II-ups-ifu.04acce83.jpg";